export default __webpack_public_path__ + "static/media/facility.38406ebd.png";